<template>
  <v-dialog
    v-model="dialog"
    width="50%"
    :fullscreen="$vuetify.breakpoint.xsOnly"
  >
    <v-form ref="form" v-model="valid" @submit.prevent="submit()">
      <v-card>
        <v-card-title>
          <span class="headline">{{ formTitle }}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <alert-message></alert-message>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-text-field
                  v-model="form.title"
                  label="Title"
                  :error-messages="[].concat(fieldErrors('form.title'))"
                  @blur="$v.form.title.$touch()"
                ></v-text-field>
              </v-col>

              <v-col cols="12" sm="12" md="12">
                <v-textarea
                  v-model="form.description"
                  label="Description"
                  :error-messages="[].concat(fieldErrors('form.description'))"
                  @blur="$v.form.description.$touch()"
                  rows="2"
                  auto-grow
                ></v-textarea>
              </v-col>
              <!-- <v-col cols="12" sm="12" md="12">
                <tags-select
                  v-model="form.tags"
                  label="Tags"
                  :filter-word="type"
                  :error-messages="[].concat(fieldErrors('form.tags'))"
                  @blur="$v.form.tags.$touch()"
                />
              </v-col> -->
              <v-col cols="12" sm="6" md="4">
                <v-text-field
                  v-model="form.quantity"
                  label="Quantity"
                  type="number"
                  :error-messages="fieldErrors('form.quantity')"
                  @blur="$v.form.quantity.$touch()"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field
                  v-model="form.cost"
                  label="Cost"
                  type="number"
                  :error-messages="fieldErrors('form.cost')"
                  @blur="$v.form.cost.$touch()"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field
                  v-model="form.price"
                  label="Price"
                  type="number"
                  :error-messages="fieldErrors('form.price')"
                  @blur="$v.form.price.$touch()"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <date-picker
                  v-model="form.date"
                  label="Date"
                  :error-messages="[].concat(fieldErrors('form.date'))"
                  @blur="$v.form.date.$touch()"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="darken-1" @click="dialog = false">Cancel</v-btn>
          <v-btn
            :disabled="$v.$invalid"
            type="submit"
            color="info"
            :loading="loading"
          >
            {{ isEdit ? "Edit" : "Add" }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex";
import _ from "lodash";
import AlertMessage from "src/components/AlertMessage";
import { required } from "vuelidate/lib/validators";
import validationMixin from "@/mixins/validationMixin";
import DatePicker from "components/DatePicker";
// import TagsSelect from "components/TagSelect.vue";
import formatterMixin from "@/mixins/formatterMixin";

const defaultForm = {
  id: "",
  title: "",
  description: "",
  date: new Date(),
  quantity: "",
  cost: "",
  price: "",
  clientId: "",
  type: "Parts",
  taxRate: 0,
  taxable: false,
  isInvoiced: false,
  tags: [],
};

export default {
  components: {
    AlertMessage,
    DatePicker,
    // TagsSelect,
  },
  props: {
    clientId: [String, Number],
    item: [Object, String],
    show: [Boolean, String],
  },
  mixins: [validationMixin, formatterMixin],
  validations: {
    form: {
      title: {
        required,
      },
      description: {},
      price: { required },
      cost: { required },
      type: {},
      quantity: { required },
      date: {},
      tags: {},
    },
  },
  validationMessages: {
    form: {
      title: {
        required: "Title required",
      },
      description: {},
      tags: {},
    },
  },

  data() {
    return {
      showDialog: this.show,
      type: "Parts",
      tags: [],
      form: {
        ...defaultForm,
        clientId: this.clientId,
      },
      dialog: false,
      valid: false,
      loading: false,
    };
  },

  watch: {
    itemById(newItem) {
      if (newItem) {
        this.form = {
          ...this.form,
          tagIds: newItem.categories.map((item) => item.id),
          tags: newItem.categories.map((item) => item.id),
        };
      }
    },
    show(n, o) {
      if (n && !o) {
        this.dialog = true;
      }
    },
    dialog(n, o) {
      if (!n && o) {
        this.onDialogClose();
      } else {
        this.onDialogOpen();
      }
    },
    item(n, o) {
      if (n && n.id && JSON.stringify(n) !== JSON.stringify(o)) {
        console.log("edited", n);
        this.form = {
          ..._.pick(n, _.keys(defaultForm)),
        };
      }
    },
  },

  computed: {
    ...mapGetters("account", ["hasAccess"]),
    ...mapState({
      account: (state) => state.account,
      alert: (state) => state.alert,
      itemById: (state) => state.item.single,
      status: (state) => state.itemPurchase.status,
    }),
    formTitle() {
      return this.isEdit ? "Edit Item Purchase" : "Add Item Purchase";
    },
    isEdit() {
      return this.optional(this.item, "id", "") ? true : false;
    },
  },

  created() {},

  methods: {
    ...mapActions("itemPurchase", ["create", "update"]),
    ...mapActions({
      getItemById: "item/getById",
      updateItem: "item/update",
    }),
    onDialogClose() {
      if (this.isEdit) {
        //
      } else {
        //
      }
      this.$emit("onClosed");
    },
    onDialogOpen() {
      this.$nextTick(() => {
        // clear error state
        this.$store.dispatch("alert/clear");
        this.$v.$reset();
      });

      if (this.item && this.item.itemId) {
        this.getItemById(this.item.itemId);
      }
    },
    save() {},
    addNew() {
      this.dialog = true;
      this.form = {
        defaultForm,
        date: this.momentLocal().format("YYYY-MM-DD"),
      };
    },

    completed() {
      this.$emit("onSucceded");
    },

    async submit() {
      this.loading = true;
      if (!this.valid) {
        this.$store.dispatch("snackbar/error", "Form invalid");
        return false;
      }

      let payload = {
        ...defaultForm,
        ...this.form,
        clientId: this.clientId,
      };

      if (this.isEdit && this.itemById) {
        await this.update({
          ...payload,
          id: this.form.id,
        });
        // await this.updateItem({
        //   ...payload,
        //   id: this.itemById.id,
        // });
      } else {
        delete payload.id;
        await this.create(payload);
      }

      if (!this.status.error) {
        this.dialog = false;
        this.completed();
      }
      this.loading = false;
    },
  },
};
</script>